import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PhasesSection } from '../components/PhasesSection';
import { AgendaSection } from '../components/AgendaSection';
import { RouteMapSection } from '../components/RouteMapSection';
import { VenueMapSection } from '../components/VenueMapSection';
import { PetWallSection } from '../components/PetWallSection';
import { TicketsSection } from '../components/TicketsSection';
import { SponsorsSection } from '../components/SponsorsSection';
import { ActivitiesSection } from '../components/ActivitiesSection';
import { LocationSection } from '../components/LocationSection';
import { CauseSection } from '../components/CauseSection';
import { ContactSection } from '../components/ContactSection';
import { SponsorsBannerSection } from '../components/SponsorsBannerSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-2239" />
      <ActivitiesSection data-id="element-2240" />
      <AboutSection data-id="element-2241" />
      <TicketsSection data-id="element-2242" />
      <CauseSection data-id="element-2243" />
      <SponsorsBannerSection data-id="element-2244" />
      <SponsorsSection data-id="element-2245" />
      <AgendaSection data-id="element-2246" />
      <RouteMapSection data-id="element-2247" />
      <VenueMapSection data-id="element-2248" />
      <PetWallSection data-id="element-2249" />
      <LocationSection data-id="element-2250" />
      <PhasesSection data-id="element-2251" />
      <ContactSection data-id="element-2252" />
    </>;
}